import { render, staticRenderFns } from "./Premiumbenefits.vue?vue&type=template&id=0279b91b&scoped=true&"
import script from "./Premiumbenefits.vue?vue&type=script&lang=js&"
export * from "./Premiumbenefits.vue?vue&type=script&lang=js&"
import style0 from "./Premiumbenefits.vue?vue&type=style&index=0&id=0279b91b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279b91b",
  null
  
)

/* custom blocks */
import block0 from "./Premiumbenefits.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports